import { render, staticRenderFns } from "./ug-selector.vue?vue&type=template&id=f51eda24"
import script from "./ug-selector.vue?vue&type=script&lang=js"
export * from "./ug-selector.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ug-selector.vue?vue&type=style&index=1&id=f51eda24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports